import { useModalStore } from 'hooks/stores/useModalStore'
import { WorkflowReassignmentsModal } from 'components/WorkflowReassignmentsModal/WorkflowReassignmentsModal'
import { State } from 'stores/Workflows/State'

export const useReassignmentsModal = () => {
  const { openModal, closeModal } = useModalStore()
  return (props: { statesToReassign: State[]; newStates: State[] }) => {
    return new Promise<Map<State, State> | null>((resolve) => {
      openModal(WorkflowReassignmentsModal, {
        customModal: true,
        modalProps: {
          onCancel: () => {
            resolve(null)
            closeModal()
          },
          onConfirm: (reassignmentsMap) => {
            resolve(reassignmentsMap)
            closeModal()
          },
          ...props,
        },
      })
    })
  }
}
